import { render } from "./AccountOverlay.vue?vue&type=template&id=021bb248&scoped=true"
import script from "./AccountOverlay.vue?vue&type=script&lang=js"
export * from "./AccountOverlay.vue?vue&type=script&lang=js"

import "./AccountOverlay.vue?vue&type=style&index=0&id=021bb248&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021bb248"]])

export default __exports__